import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Store, select } from '@ngrx/store';
import { Observable } from 'rxjs';
import { CandidateService } from 'src/app/services/candidate.service';
import { ReportService } from 'src/app/services/report.service';
import { setCandidate } from 'src/app/actions/candidate.actions';
import { fromCandidate } from 'src/app/reducers/candidate.reducer';
import { Candidate } from 'src/app/models/candidate.model';
import { Test, TestLite } from 'src/app/models/test.model';
import { Invitation } from 'src/app/models/invitation.model';
import { AppConfig } from 'src/app/helpers/app.config';
import { TranslateService } from '@ngx-translate/core';
import { UtilsService } from 'src/app/services/utils.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'ct-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit, OnDestroy {

  @ViewChild('feedbackModal') feedbackModal;

  candidate$: Observable<Candidate>;
  status = '';
  languageId: number;
  token: string;
  returnTest: TestLite;
  feedbackAvailableTests = [25, 26];
  testNotFinalized = 0;
  testFinalized = 0;
  today = (new Date()).getTime();
  currentProject = 0;

  public environmentId = AppConfig.settings.ENVIRONMENT_ID;
  public evalualiaUrl = AppConfig.settings.EVALUALIA + '/0-login';

  constructor(
    private store: Store,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private candidateService: CandidateService,
    private reportService: ReportService,
    public translateService: TranslateService,
    public utilsService: UtilsService,
    public modal: NgbModal
  ) { }

  ngOnInit(): void {
    this.token = this.activatedRoute.snapshot.paramMap.get('token');
    this.candidate$ = this.store.pipe(select(fromCandidate.selectCandidateState));
    this.candidateService.getByToken(this.token).subscribe(candidate => {
      const currentLang = this.utilsService.getLanguageFromLanguageId(
        candidate.invitationsLite.find(invitation => invitation.token === this.token)?.languageId
      )
      this.translateService.use(currentLang);
      this.translateService.setDefaultLang(currentLang);
      document.documentElement.lang = currentLang.split('-')[0];

      const invitation = candidate.invitationsLite.find(invitation => invitation.token === this.token);
      if (invitation.project && invitation.project.id) {
        document.getElementById('candidateModule').style.setProperty('--color-primary', invitation.project.primaryColor);
        document.getElementById('candidateModule').style.setProperty('--color-secondary', invitation.project.secondaryColor);
        document.getElementById('candidateModule').style.setProperty('--color-tertiary', invitation.project.tertiaryColor);
        document.getElementById('candidateModule').style.setProperty('--color-quaternary', invitation.project.quaternaryColor);
        document.getElementById('candidateModule').style.setProperty('--color-quinary', invitation.project.quinaryColor);
        document.getElementById('candidateModule').style.setProperty('--color-senary', invitation.project.senaryColor);
        document.getElementById('candidateModule').style.setProperty('--color-septenary', invitation.project.septenaryColor);
        document.getElementById('candidateModule').style.setProperty('--color-octonary', invitation.project.octonaryColor);
        document.getElementById('candidateModule').style.setProperty('--color-nonary', invitation.project.nonaryColor);
        this.currentProject = invitation.project.id;
      }

      candidate.invitationsLite.forEach(invitation => {
        invitation.tests.forEach(test => {
          if (['pending', 'active', 'expired'].includes(test.status)) { this.testNotFinalized++ }
          if (['completed'].includes(test.status)) { this.testFinalized++ }
        })
      })

      this.store.dispatch(setCandidate(candidate));

      setTimeout(() => {
        this.showFeedback(candidate);
      }, 200);
    }, error => {
      this.router.navigate(['error/general']);
    });
  }

  ngAfe

  showFeedback(candidate) {
    const returnTestToken = this.activatedRoute.snapshot.queryParamMap.get('testToken');

    this.returnTest = candidate.invitationsLite.find(
      invitation => invitation.tests.find(test => test.token === returnTestToken)
    )?.tests.find(test => test.token === returnTestToken);

    if (this.feedbackAvailableTests.includes(this.returnTest?.testModelId)
      && this.returnTest.status === 'completed' && !this.returnTest.result.feedbackScore) {
      this.feedbackModal.openModal();
    }
  }

  testAction(test: Test, invitation: Invitation) {
    if (test.status.toLowerCase() === 'pending' || test.status.toLowerCase() === 'active') { this.navigateToTest(this.testUrl(test, invitation)) }
    // solo se ejecuta la accion de informe si ha pasado menos de un año desde la finalización del test
    else if ((test.status.toLowerCase() === 'completed') && (test.status.toLowerCase() === 'completed') && ((new Date(test.result.finishedAt).getTime() + 31556952000) > this.today)) {
      if ((test.testModelId === 1 || test.testModelId === 2) && test.notifyCtReport) { this.viewCTReport(test) }
      else if (test.notifyMindsetDigitalReport) { this.viewMDReport(test) }
      else if (test.testModelId >= 24 && test.notifyCtReport) { this.viewCTReport(test) }
      else if (!test.notifyAdnReport && !test.notifyMindsetDigitalReport && !test.notifyCtReport) { }
    }
  }

  viewMDReport(test: Test) {
    this.languageId = this.utilsService.getLanguageIdFromLanguage(this.translateService.currentLang);

    if (test.result.mindsetDigital) {
      window.open('/#/report/md/' + test.result.reportMindsetDigitalToken + '?languageId=' + this.languageId, '_blank');
    } else {
      this.utilsService.toast('warning', 'NoAdnResult');
      this.ngOnInit();
    }
  }

  viewCTReport(test: Test) {
    this.languageId = this.utilsService.getLanguageIdFromLanguage(this.translateService.currentLang);
    window.open('/#/report/ct/' + test.result.reportCandidateTestingToken + '?languageId=' + this.languageId, '_blank');
  }

  testUrl(test: Test, invitation: Invitation): string {
    let url: string;

    if (test.testModel.origin === 'evalualia') {
      url = this.evalualiaUrl + test.url + '&env=' + this.environmentId + '&returnCT=' + invitation.token;
    } else if (test.testModel.origin === 'ct') {
      url = '/#/candidate/test/' + test.token;
    }

    return url;
  }

  navigateToTest(url) {
    window.open(url, '_blank').focus();
  }

  contextualClass(status: string, prefix = ''): string {
    let className;
    switch (status.toLowerCase()) {
      case 'completed': className = 'primary'; break;
      case 'processing': className = 'primary'; break;
      case 'active': className = 'success'; break;
      case 'expired': className = 'danger'; break;
      case 'pending': className = 'warning'; break;
    }
    return prefix ? prefix + '-' + className : className;
  }

  ngOnDestroy(): void {
    this.modal.dismissAll();
  }

}
